import { put, call, select, takeLatest } from "redux-saga/effects"
import { get, keys } from "lodash"
import ActionTypes from "../../enums/ActionTypes"
import { get as getHttp } from "../../utils/http"
import { API_SERVER_USER } from "../../constants/api"
import { formatAPIResponse } from "../../utils/api"
import { createAction } from "../../utils/redux"
import { getUserData } from "../selectors"
import { AuthenticationState } from "../../types/ReduxStateExtensions"
import { checkForValidSession, goToLogin } from "./authentication"

const tryRequestUserRights = (userId: number, token: string) => 
  getHttp({
    url: `${API_SERVER_USER}/users/${userId}/userRights`,
    token,
  }).then(formatAPIResponse)


  function* fetchUserRights(token: string, userId: number) {
    try {
      const userRights = (yield call(tryRequestUserRights, userId, token)) as object
      yield put(createAction(ActionTypes.USER_RIGHTS_SUCCESS, { userRights }))
    } catch (e) {
      yield put(createAction(ActionTypes.USER_RIGHTS_FAILURE))
    }
  }

  function* requestUserRights() {
    const { token, userId } = (yield select(getUserData)) as AuthenticationState
  
    yield fetchUserRights(token, userId)
  }

  function* requestUserRightsUpdate({ payload }: { type: string, payload: object}) {
    const users = get(payload, "entities.userDetails") || {}
    const userIds = keys(users)
    const { token, userId } = (yield select(getUserData)) as AuthenticationState

    try {
      yield checkForValidSession(token)
      if (userIds.includes(`${userId}`) && token && userId) {
        yield call(fetchUserRights, token, userId)
      }
    } catch (e) {
      yield call(goToLogin)
    }

  }

export default [
  takeLatest(ActionTypes.USER_RIGHTS_REQUEST, requestUserRights),
  /* update logged in user's rights if logged in user's rights were changed */
  takeLatest(ActionTypes.USERS_UPDATE_SUCCESS, requestUserRightsUpdate),
]